import { FormData } from "./client.booking";

export const steps = ["Client", "Deceased", "Service", "Package"];

export const packages = [
  {
    id: "muzukuru-x",
    name: "Muzukuru X",
    price: 499,
    icon: "💎",
    color: "#8B5A2B",
    popular: false,
    features: ["2 Camera Setup", "Broadcast On Youtube"],
  },
  {
    id: "muzukuru-pro",
    name: "Muzukuru Pro",
    price: 699,
    icon: "🏆",
    color: "#4CAF50",
    popular: true,
    features: ["3 Camera Setup", "Broadcast On Youtube"],
  },
  {
    id: "muzukuru-lux",
    name: "Muzukuru Lux",
    price: 1299,
    icon: "❤️",
    color: "#E91E63",
    popular: false,
    features: ["4 Camera Setup", "Broadcast On Youtube"],
  },
];

export const addOnsList = [
  {
    id: "screen",
    name: "Screen",
    description: "3m x 2m LED Screen",
    price: 439,
  },
  {
    id: "video-audio",
    name: "Video & Audio",
    description: "Projector Screen 8ft",
    price: 50,
  },
];

export const defaultFormData: FormData = {
  clientTitle: "Mr",
  clientName: "",
  clientSurname: "",
  clientPhone: "",
  clientEmail: "",
  clientNotes: "",
  deceasedTitle: "Mr",
  deceasedName: "",
  deceasedSurname: "",
  deceasedGender: "Male",
  sunriseDate: null,
  sunsetDate: null,
  venueName: "",
  address01: "",
  address02: "",
  serviceDate: null,
  startTime: null,
  endTime: null,
  selectedPackage: "",
  addOns: [],
};

// ─── DYNAMIC STYLES (NEW) ───────────────────────────────────────────────────

/**
 * Returns custom styling for Form fields using exact Redux colors.
 */
export const getFieldSx = (color400?: string) => ({
  "& .MuiInputLabel-root": {
    position: "static",
    transform: "none",
    fontSize: 11,
    fontWeight: 600,
    mb: "4px",
    lineHeight: 1.3,
    color: "#000000", // Forced black labels
    "&.Mui-focused": {
      color: color400 || "#8B5A2B",
    },
  },
  "& .MuiInputLabel-asterisk": {
    color: color400 || "#8B5A2B",
  },
  "& .MuiFormLabel-root": { transformOrigin: "unset" },
  "& .MuiOutlinedInput-root": {
    borderRadius: "6px",
    backgroundColor: "#fff",
    fontSize: 13,
    "& fieldset": {
      borderColor: "#e0e0e0",
      top: 0,
      "& legend": { display: "none" },
    },
    "&:hover fieldset": { borderColor: "#bdbdbd" },
    "&.Mui-focused fieldset": {
      borderColor: color400 || "#8B5A2B",
      borderWidth: "1.5px",
    },
  },
  "& .MuiInputBase-input": {
    padding: "6px 10px",
  },
  "& .MuiInputBase-inputMultiline": { padding: 0 },
});

export const getPickerSlots = (color400?: string) => ({
  textField: {
    size: "small" as const,
    fullWidth: true,
    InputLabelProps: { shrink: true },
    sx: getFieldSx(color400),
  },
});

// ─── BACKWARD COMPATIBLE FALLBACKS (PREVENTS COMPILING ERRORS) ──────────────

/**
 * Static fallbacks using the original brown color theme.
 * Keeps existing components from throwing import errors.
 */
export const fieldSx = {
  "& .MuiInputLabel-root": {
    position: "static",
    transform: "none",
    fontSize: 11,
    fontWeight: 600,
    mb: "4px",
    lineHeight: 1.3,
    color: "#000000",
    "&.Mui-focused": { color: "#8B5A2B" },
  },
  "& .MuiInputLabel-asterisk": { color: "#8B5A2B" },
  "& .MuiFormLabel-root": { transformOrigin: "unset" },
  "& .MuiOutlinedInput-root": {
    borderRadius: "6px",
    backgroundColor: "#fff",
    fontSize: 13,
    "& fieldset": {
      borderColor: "#e0e0e0",
      top: 0,
      "& legend": { display: "none" },
    },
    "&:hover fieldset": { borderColor: "#bdbdbd" },
    "&.Mui-focused fieldset": { borderColor: "#8B5A2B", borderWidth: "1.5px" },
  },
  "& .MuiInputBase-input": { padding: "6px 10px" },
  "& .MuiInputBase-inputMultiline": { padding: 0 },
};

export const pickerSlots = {
  textField: {
    size: "small" as const,
    fullWidth: true,
    InputLabelProps: { shrink: true },
    sx: fieldSx,
  },
};
